/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends } from "tslib";
import { DependencyObject } from "igniteui-react-core";
import { INotifyPropertyChanged_$type, PropertyChangedEventArgs, markType, markDep } from "igniteui-react-core";
import { DependencyProperty } from "igniteui-react-core";
import { Brush } from "igniteui-react-core";
import { PropertyMetadata } from "igniteui-react-core";
/**
 * @hidden
 */
var XamLinearGraphRange = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(XamLinearGraphRange, _super);
    function XamLinearGraphRange() {
        var _this = _super.call(this) || this;
        _this.propertyChanged = null;
        return _this;
    }
    XamLinearGraphRange.prototype.ac = function (a, b, c) {
    };
    XamLinearGraphRange.prototype.ab = function (a, b, c) {
        this.ac(a, b, c);
        if (this.propertyChanged != null) {
            this.propertyChanged(this, new PropertyChangedEventArgs(a));
        }
    };
    XamLinearGraphRange.$t = markType(XamLinearGraphRange, 'XamLinearGraphRange', DependencyObject.$, [INotifyPropertyChanged_$type]);
    XamLinearGraphRange.$$p = markDep(DependencyProperty, PropertyMetadata, XamLinearGraphRange, 'ab', ['Brush:an:ad', [Brush.$, null], 'EndValue:j:ae', [1, NaN], 'InnerEndExtent:k:af', [1, NaN], 'InnerStartExtent:l:ag', [1, NaN], 'Name:u:ah', [2, null], 'OuterEndExtent:m:ai', [1, NaN], 'OuterStartExtent:n:aj', [1, NaN], 'Outline:ao:ak', [Brush.$, null], 'StartValue:o:al', [1, NaN], 'StrokeThickness:p:am', [1, 1]]);
    return XamLinearGraphRange;
}(DependencyObject));
export { XamLinearGraphRange };
